module.exports = __webpack_public_path__ + "img/sack-dollar-solid.c2709c25.svg";